import { SET_EVENT_FS_OBJECT_SORTING } from 'actions/Types';

export default (
  state = {
    sortDirection: 'desc',
    sortBy: 'type'
  },
  action
) => {
  if (action.type === `${SET_EVENT_FS_OBJECT_SORTING}`) {
    return action.payload;
  }

  return state;
};
